<!--
 * @Author: ghy
 * @Date: 2023-07-18 16:06:07
 * @LastEditors: ghy
 * @LastEditTime: 2023-10-08 13:47:59
 * @Description: 
-->
<template>
  <div class="noticeList">
    <cus-title text="通知公告"></cus-title>
    <ul>
      <li v-for="(item, index) in noticeList" :key="index" @click="toDetails(item)">
        <div>
          <span></span>
          <span
            class="spanCss"
            v-if="item.tags != null && item.tags == 2"
            >重要</span
          >
          <span
            class="spanCss"
            v-if="item.isExpired === 0"
            >最新</span
          >
          <span v-html="showKeyWord(item.noticeTitle,searchValue)" class="spanText"
            ></span
          >
        </div>
        <div>{{ parseTime(item.addTime) }}</div>
      </li>
    </ul>
    <div class="pagination-box">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        background
        :page-size="10"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import { findCheckedNoticePage } from "@/api/notice.js";
export default {
  data(){
    return {
      noticeList:[],
      pageNo:1,
      pageSize:10,
      total:null
    }
  },
  mounted(){
    this.searchValue = this.$route.query.searchValue
    this.findCheckedNoticePage()
  },
  methods:{
    async findCheckedNoticePage() {
      const res = await findCheckedNoticePage({
        pageNo:this.pageNo,
        pageSize:this.pageSize,
      });
      this.noticeList = res.data.listData.content;
      this.total = res.data.listData.totalElements
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.findCheckedNoticePage()
    },
    toDetails(item){
      let routeData = this.$router.resolve({
        path: "/noticeDetails",
        query: {
          keyId: item.noticeId,
        },
      });
      window.open(routeData.href, '_blank')
    },
  }
};
</script>

<style lang="less">
.noticeList {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  > ul {
    margin-top: 30px;
      > li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        cursor: pointer;
        > div:nth-child(1) {
          display: flex;
          align-items: center;
          > span {
            &:nth-child(1) {
              width: 8px;
              height: 8px;
              background: #333333;
              border-radius: 50%;
              margin-right: 6px;
            }
          }
        }
        > div:nth-child(2) {
          font-size: 21px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #aeaeae;
          line-height: 21px;
        }
      }
    }
}
.spanCss {
  width: 55px;
  height: 30px;
  border: 1px solid #d9001b;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 21px;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d9001b;
  line-height: 30px;
}
.spanText {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  max-width: calc(900px - 57.5px); /* 限制最大宽度，你可以根据需要调整这个值 */
  text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
  overflow: hidden; /* 隐藏溢出的文本 */
  white-space: nowrap; /* 防止文本换行 */
}
.pagination-box {
    display: flex;
    justify-content: center;
    margin-top:66px;
  }
</style>


// WEBPACK FOOTER //
// src/views/notice/noticeList.vue